import React from 'react'
import FirmMain from './FirmMain'
function FirmHome() {
    return (
        <FirmMain selectedKeys={['home']} leftSelectedKeys={['home']}>
            <div>亲爱的用户，欢迎您使用我们的服务！</div>
        </FirmMain>
    )
}

export default FirmHome